import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { UNIT_STORAGE_KEY } from './unitConversions';

export function initialUnitSystem({ storage } = {}) {
  try {
    const browserStorage = storage === undefined && typeof window !== 'undefined' ? window.localStorage : storage;
    const saved = browserStorage?.getItem(UNIT_STORAGE_KEY);
    if (saved === 'metric' || saved === 'inch') return saved;
  } catch { /* unavailable browser storage uses the metric default */ }
  return 'metric';
}

const UnitContext = createContext({ unitSystem: 'metric', setUnitSystem: () => {}, isMetric: true, isInch: false });

export function UnitProvider({ children }) {
  const [unitSystem, setState] = useState(initialUnitSystem);
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const synchronizeUnitSystem = (event) => {
      if (event.key !== UNIT_STORAGE_KEY) return;
      if (event.newValue === 'metric' || event.newValue === 'inch') setState(event.newValue);
    };
    window.addEventListener('storage', synchronizeUnitSystem);
    return () => window.removeEventListener('storage', synchronizeUnitSystem);
  }, []);
  const setUnitSystem = useCallback(choice => {
    if (choice !== 'metric' && choice !== 'inch') return;
    setState(choice);
    try { window.localStorage.setItem(UNIT_STORAGE_KEY, choice); } catch { /* storage can be disabled */ }
  }, []);
  return <UnitContext.Provider value={{ unitSystem, setUnitSystem, isMetric: unitSystem === 'metric', isInch: unitSystem === 'inch' }}>{children}</UnitContext.Provider>;
}

export function useUnits() {
  return useContext(UnitContext);
}
